<template>
  <div class="">
    <div>
      <b-tabs content-class="pt-1" lazy v-model="tabIndex">
        <b-tab
          v-for="(tab, index) in tabs"
          :key="index"
          @click="onTabClick(tab, index)"
          :title="tab.text"
          :active="active(index)"
          title-item-class="lisaweb"
        >
          <keep-alive>
            <component :is="selected"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Transmission from "@/components/fattutto/transmission/index.vue";
import Configuration from "@/components/fattutto/configuration/index.vue";
import ShortcutsAndBreadcrumbsMixin from "@/mixins/ShortcutsAndBreadcrumbsMixin";

export default {
  mixins: [ShortcutsAndBreadcrumbsMixin],
  data() {
    return {
      path: "module.FATT",
      tabs: [
        { name: "Transmission", text: "Trasmissioni" },
        { name: "Configuration", text: "Configurazioni" },
      ],
      tabsGroup: "Management",
      // breadcrumbs settings: bcs & maxLevel
      bcs: [
        {
          text: "Fattutto",
          path: "",
          level: 0,
          disabled: true,
        },
        {
          text: "Fattutto",
          path: "",
          level: 1,
        },
        {
          text: "Trasmissioni",
          path: "module.FATT",
          tab: `#${this.selected}`,
          level: 2,
        },
      ],
      maxLevel: 2, // use to identify the tabs level
      selected: "Transmission",
      tabIndex: 0,
      // isLoading: false,
    };
  },
  components: {
    Transmission,
    Configuration,
  },
};
</script>
